<script>
import Modal from '@/components/atoms/Modal'
import ButtonLoader from '@/components/atoms/ButtonLoader'
export default {
    name: 'ModalConfirm',
    components: { ButtonLoader, Modal },
    props: {
        value: Boolean,
        hideButton: Boolean,
        disabled: Boolean,
        action: Function,
        buttonClass: {
            type: String,
            default: 'btn btn-link',
        },
        buttonConfirmClass: {
            type: String,
            default: 'btn btn-primary',
        },
        headerLevel: {
            type: String,
            default: 'h1',
        },
        headerLabel: {
            type: String,
            default: 'labels.confirm_title',
        },
        cancelLabel: {
            type: String,
            default: 'base.cancel',
        },
        confirmLabel: {
            type: String,
            default: 'base.confirm',
        },
        cancelIcon: {
            type: String,
            default: undefined,
        },
        confirmIcon: {
            type: String,
            default: undefined,
        },
        bodyLabel: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            loading: false,
            attr: undefined,
            isOpen: false,
        }
    },
    watch: {
        value: {
            handler(value) {
                if (value) this.open()
            },
        },
    },
    methods: {
        open(attr) {
            this.isOpen = true
            this.$emit('input', true)
            this.attr = attr
        },
        close() {
            this.isOpen = false
            this.$emit('input', false)
            this.attr = undefined
            this.$nextTick(() => {
                this.$emit('closed')
            })
        },
        async confirm() {
            if (!this.action) {
                this.$emit('confirm')
                this.close()
                return
            }
            this.loading = true
            try {
                await this.action(this.attr)
                this.close()
            } finally {
                this.loading = false
            }
        },
        cancel() {
            this.$emit('cancel')
            this.close()
        },
    },
}
</script>

<template lang="pug">
.modal-confirm
    button(v-if="!hideButton" :class="buttonClass" :key="buttonClass" :disabled="disabled" @click="open")
        slot
    modal(ref="ModalConfirm" v-model="isOpen" :closable="false")
        template(v-slot:header)
            component(:is="headerLevel")
                slot(name="header")
                template(v-if="!$slots.header") {{ headerLabel }}
        template(v-if="bodyLabel" v-slot:body)
            p.mb-0(v-if="bodyLabel" :inner-html.prop="bodyLabel")
        template(v-slot:footer)
            slot(name="footer")
            template(v-if="!$slots.footer")
                button.btn.btn-secondary(@click="cancel")
                    icon.mr-2(v-if="cancelIcon" :icon="cancelIcon")
                    | {{ cancelLabel }}
                button-loader(@click="confirm" :class="buttonConfirmClass" :loading="loading" inline)                     
                    icon.mr-2(v-if="confirmIcon" :icon="confirmIcon")
                    | {{ confirmLabel }}
</template>
